module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sdgTitle":"SDGs","euTaxonomyTitle":"EU Taxonomy","irisTitle":"IRIS+"},"de":{"sdgTitle":"SDGs","euTaxonomyTitle":"EU-Taxonomie","irisTitle":"IRIS+"}}')
  delete Component.options._Ctor
}
